/*
 * Copyright (c) 2023-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {EsciMessageService} from '../shared/esci-message.service';
import {FileUploadService} from '../service/file-upload.service';
import {AuthenticationService} from '../core/authentication/authentication.service';
import {EsciService} from '../service/esci.service';
import {FileDownloadService} from '../service/file-download.service';
import {ValidationService} from '../service/validation.service';
import {ConfirmationService} from 'primeng/api';
import {Directive, signal} from '@angular/core';
import {ExcelService} from '../service/excel.service';
import {
    SizeColumnsToContentStrategy,
    SizeColumnsToFitGridStrategy,
    SizeColumnsToFitProvidedWidthStrategy
} from 'ag-grid-community';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../shared/user.service';
import {DialogService} from 'primeng/dynamicdialog';
import {HttpClient} from "@angular/common/http";
import {FormBuilder} from "@angular/forms";

@Directive()
export class EsciComponent {
  permissionUrl: string;
  adminPermissionUrl?: string;
  readonly permission = signal<boolean>(false);
  readonly adminPermission = signal<boolean>(false);
  readonly hasPurchAdminPermission = signal<boolean>(false);
  /** True iff the current user has the COMPONENT_TIER_N_ADMIN role (mirrors hasPurchAdminPermission). */
  readonly hasTierNAdminPermission = signal<boolean>(false);
  readonly canExport = signal<boolean>(false);
  MAX_FILE_SIZE = 500000;
  /** Optional hook invoked after admin permission check completes (success or error). */
  onAdminPermissionResolved?(): void;
  /** Optional hook invoked after view, full-admin, and both partial-editor permission checks have all settled. */
  onAccessPermissionsResolved?(): void;
  public autoSizeStrategy:
      | SizeColumnsToFitGridStrategy
      | SizeColumnsToFitProvidedWidthStrategy
      | SizeColumnsToContentStrategy
       = {
    type: 'fitGridWidth',
  };
  constructor(public uploadService: FileUploadService, public authService: AuthenticationService,
              public esciService: EsciService, public downloadService: FileDownloadService,
              public messageService: EsciMessageService, public validatorService: ValidationService,
              public confirmationService: ConfirmationService, public excelService: ExcelService,
              public route: ActivatedRoute, public router: Router, public userService: UserService,
              public dialogService: DialogService, public http: HttpClient, public fb: FormBuilder) {
    if (!this.authService.userInfo || !this.authService.userInfo.gmin) {
      this.messageService.processError('Authentication service could not identify current user\'s gmin.');
    }
  }

  onFileSelected(file: File[], fileMember: string) {
    this[fileMember] = null;
    if (file && file.length === 1) {
      this[fileMember] = file[0];
    }
  }

  onFilesSelected(files: File[], fileMember: string) {
    if (!this[fileMember]) {
      this[fileMember] = [];
    }
    this[fileMember].length = 0;
    if (files) {
      this[fileMember].push(...files);
    }
  }

}
